import { computed, type Ref } from "vue";
import {
	useInternalFormApi,
	type ErrorsByCause,
	type GenericValues,
	type InternalFormApiId,
} from "./form-context";
import type { Path } from "./types";

export function useFieldErrors<TValues extends GenericValues, TPath extends Path<TValues>>(
	id: InternalFormApiId<TValues>,
	path: TPath
): Ref<ErrorsByCause> {
	const {
		state: { errors, metas },
	} = useInternalFormApi(id);

	const fieldErrors = computed({
		get: () => {
			if (!metas[path]?.touched && !metas[path]?.dirty) return {};

			return errors[path] || {};
		},
		set: (e) => {
			errors[path] = e;
		},
	});

	return fieldErrors;
}
